webpackJsonp([9],{

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  data: function data() {
    return {
      err: '',
      success: '',
      selectedWebshops: [],
      isLocalAdmin: false,
      moon: {
        activate: true,
        error: false,
        success: false
      },
      webshops: []
    };
  },
  methods: {
    activate: function activate() {
      var _this = this;

      var actions = [];
      var hasErrors = false;
      if (this.moon.activate) {
        actions.push(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
          _this.$http.post('catalog/activate/' + _this.data.catalogId, {}).then(function (res) {
            if (res.body.status !== 'Success') {
              _this.moon.error = true;
              hasErrors = true;
              resolve();
              return;
            }
            _this.moon.error = false;
            _this.moon.activate = false;
            _this.moon.success = true;
            resolve();
          }).catch(function (e) {
            _this.moon.error = true;
            hasErrors = true;
            resolve();
          });
        }));
      }
      var webshopSuccess = [];
      if (this.selectedWebshops.length > 0) {
        actions.push.apply(actions, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.webshops.filter(function (webshop) {
          return _this.selectedWebshops.includes(webshop.id);
        }).map(function (webshop) {
          return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            _this.$http.post('webshopresource/catalog/switchversionandview/' + webshop.id, {
              catalogViewId: _this.data.catalogViewId,
              catalogVersion: _this.data.catalogVersion
            }).then(function (res) {
              if (res.body.status !== 'Success') {
                _this.$set(webshop, 'error', true);
                hasErrors = true;
                resolve();
                return;
              }
              _this.$set(webshop, 'error', false);
              _this.$set(webshop, 'success', true);
              webshopSuccess.push(webshop.id);
              resolve();
            }).catch(function (e) {
              _this.$set(webshop, 'error', true);
              hasErrors = true;
              resolve();
            });
          });
        })));

        // this.webshops.forEach((webshop) => {
        //   if (this.selectedWebshops.includes(webshop.id)) {
        //     actions.push();
        //   }
        // });
      }
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(actions).then(function () {
        if (hasErrors) {
          _this.err = 'Failed to activate on all resources';
          // if (this.isLocalAdmin) return;
          _this.selectedWebshops = _this.selectedWebshops.filter(function (current) {
            return !webshopSuccess.includes(current.id);
          });
          return;
        }
        _this.$emit('close', _this.moon.success);
      });
    },
    generateWebshopData: function generateWebshopData(webshop) {
      var data = {
        name: webshop.name,
        planetInstanceId: webshop.planetInstanceId,
        email: webshop.email,
        subscriptionModel: webshop.subscriptionModel,
        catalogViewId: this.data.catalogViewId,
        catalogVersion: this.data.catalogVersion,
        paymentTypes: webshop.paymentTypes,
        orderTypes: webshop.orderTypes,
        sendToMoon: webshop.sendToMoon,
        minDeliveryAmount: webshop.minDeliveryAmount,
        rules: webshop.rules,
        confirmationEmailPrefix: webshop.confirmationEmailSettingsDetails ? webshop.confirmationEmailSettingsDetails.prefix || null : null,
        confirmationEmailPostFix: webshop.confirmationEmailSettingsDetails ? webshop.confirmationEmailSettingsDetails.postfix || null : null,
        bccEmail: webshop.confirmationEmailSettingsDetails ? webshop.confirmationEmailSettingsDetails.bccEmail || null : null,
        orderSubmissionAllowedFrom: webshop.orderSubmissionAllowedFrom,
        deliveryDurationFrom: webshop.deliveryDurationFrom,
        deliveryDurationTo: webshop.deliveryDurationTo
      };
      if (webshop.paymentGatewaySettingDetails) {
        data.paymentGateway = webshop.paymentGatewaySettingDetails.paymentGateway;
        if (data.paymentGateway === 'paymentsense') {
          data.merchantId = webshop.paymentGatewaySettingDetails.merchantId;
          data.preSharedKey = webshop.paymentGatewaySettingDetails.preSharedKey;
        }
      }
      return data;
    }
  },
  created: function created() {
    var _this2 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    // if (this.isLocalAdmin) return;
    if (this.data.webshops) {
      this.webshops = this.data.webshops.map(function (webshop) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, webshop, { error: false, success: false });
      });
      this.webshops.forEach(function (webshop) {
        return _this2.selectedWebshops.push(webshop.id);
      });
      // {
      //   catalogId: data.catalogId,
      //   companyId: this.selectedCompany.id,
      //   webshops
      // }
    }
  }
});

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$lang.labels.catalogActivationText))]), _vm._v(" "), _c('v-checkbox', {
    key: _vm.index,
    attrs: {
      "hide-details": "",
      "color": "primary",
      "error": _vm.moon.error,
      "success": _vm.moon.success,
      "label": _vm.$lang.labels.moon
    },
    model: {
      value: (_vm.moon.activate),
      callback: function($$v) {
        _vm.$set(_vm.moon, "activate", $$v)
      },
      expression: "moon.activate"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_vm._l((_vm.webshops), function(webshop, index) {
    return [_c('v-checkbox', {
      key: index,
      attrs: {
        "hide-details": "",
        "color": "primary",
        "error": webshop.error,
        "success": webshop.success,
        "value": webshop.id,
        "label": ((_vm.$lang.labels.webshop) + " - " + (webshop.name))
      },
      model: {
        value: (_vm.selectedWebshops),
        callback: function($$v) {
          _vm.selectedWebshops = $$v
        },
        expression: "selectedWebshops"
      }
    })]
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.no))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.activate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.yes))])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(580),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/9.020b48345309708a34ef.js